interface StateDisplayProps {
  states: string[]
  type: 'projected' | 'delivered'
  label: string
  'data-testid'?: string
}

export default function StateDisplay ({ states, type, label, 'data-testid': testId }: StateDisplayProps) {
  const colorClass = type === 'projected' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'

  return (
    <div className='border rounded-md p-3 bg-gray-50 min-h-[80px]' data-testid={testId}>
      <div className='text-sm font-medium text-gray-700 mb-2'>{label} ({states.length})</div>
      {states.length > 0
        ? (
          <div className='flex flex-wrap gap-1'>
            {states.map(state => (
              <span key={state} className={`${colorClass} px-2 py-1 rounded text-xs font-medium`}>
                {state}
              </span>
            ))}
          </div>
          )
        : (
          <div className='text-sm text-gray-500'>No states selected</div>
          )}
    </div>
  )
}
